// extracted by mini-css-extract-plugin
export default {"trigger":"InfoTooltip_trigger__VjOVy","description":"InfoTooltip_description__YXJSz","formulaLabel":"InfoTooltip_formulaLabel__Mr0us","formula":"InfoTooltip_formula__6bRrK"};